//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyTable from '../../components/Card/CardPropertyTable.vue'
import EmployeePropertyWorkAreaScheduleEdit from './EmployeePropertyWorkAreaScheduleEdit.vue'

export default {
  name: 'EmployeePropertyWorkAreaSchedule',
  components: {
    CardPropertyTable,
    EmployeePropertyWorkAreaScheduleEdit
  },
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  }
}
